import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { ThirdwebProvider, ConnectWallet, metamaskWallet, coinbaseWallet, walletConnect, trustWallet, darkTheme, useAddress, useSigner } from "@thirdweb-dev/react";
import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";
import './App.css';

const contractAddress = "0x61d7F7aDD12161029037b5Ee827aBd2BDCfC0aDc"; 
const abi = [{"inputs":[{"internalType":"address","name":"_badBoysContractAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"AccessControlBadConfirmation","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bytes32","name":"neededRole","type":"bytes32"}],"name":"AccessControlUnauthorizedAccount","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"previousAdminRole","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"newAdminRole","type":"bytes32"}],"name":"RoleAdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleGranted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleRevoked","type":"event"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"}],"name":"Buy2Get1","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"CROSSMINT_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"DEFAULT_ADMIN_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"badBoysContract","outputs":[{"internalType":"contract IBadBoysWeb3","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"}],"name":"getRoleAdmin","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"crossmintAddress","type":"address"}],"name":"grantCrossmintRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manualMintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"callerConfirmation","type":"address"}],"name":"renounceRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"revokeRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setManualMintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"teamWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawETH","outputs":[],"stateMutability":"nonpayable","type":"function"}];

const WalletConnectedContent = () => {
  const [quantity, setQuantity] = useState(1);
  const [manualMintPrice, setManualMintPrice] = useState('0.055');
  const [totalPrice, setTotalPrice] = useState('0');
  const userWalletAddress = useAddress();
  const signer = useSigner();

  useEffect(() => {
    const fetchManualMintPrice = async () => {
      if (signer) {
        const contract = new ethers.Contract(contractAddress, abi, signer);
        try {
          const price = await contract.manualMintPrice();
          setManualMintPrice(ethers.utils.formatEther(price));
        } catch (error) {
          console.error("Error fetching manual mint price:", error);
        }
      }
    };

    fetchManualMintPrice();
  }, [signer]);

  useEffect(() => {
    setTotalPrice((Number(manualMintPrice) * quantity).toFixed(3));
  }, [quantity, manualMintPrice]);

  const handleMint = async () => {
    if (!signer || quantity < 1) return;

    try {
      const contract = new ethers.Contract(contractAddress, abi, signer);
      const mintValue = ethers.utils.parseEther((Number(manualMintPrice) * quantity).toString());
      const transaction = await contract.Buy2Get1(quantity, userWalletAddress, { value: mintValue });
      await transaction.wait();
      alert('Minting successful!');
    } catch (error) {
      console.error("Minting failed:", error);
      alert('Minting failed. Check console for details.');
    }
  };

  return (
    
<div className="mint-container">
    <h2 className="white-text">
      MINT YOUR BAD BOY DIGITAL COLLECTIBLE VIA <span style={{ color: '#04d8a4' }}>CROSSMINT</span>
    </h2>
    <div className="reg-text">LEVEL: EASY | MAX 10 PER TRANSACTION | ACCEPTS [ETH] [SOL] [CREDIT CARDS]</div>

    <hr></hr>

      <div className="minting-section">
        <img
          src="https://i.ibb.co/fqHP9YD/promo.gif"
          alt="Promo"
          className="promo-gif"
        />
        <div className="minting-controls">
          <div className="quantity-picker-container quantity-picker select">
            <select
              id="quantity"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
            >
              {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>
          <div className="mint-component">
      <CrossmintPayButton
        projectId="f7499dd9-b9c4-42e8-b096-b645b9e59c51"
        collectionId="fed1e62c-c6d2-4226-bb99-47a53d26b3b6"
        environment="production"
        mintConfig={{
          amount: quantity.toString(),
          totalPrice: totalPrice
        }}
      />
    </div>

        </div>

      </div>
<hr></hr><hr></hr>

      <h2 className="white-text">
        MINT YOUR BAD BOY DIGITAL COLLECTIBLE VIA <span style={{ color: 'red' }}>CONTRACT</span>
      </h2>
      <div className="reg-text">UNLIMITED PER TRANSACTION | ACCEPTS [ETH]</div><br></br>
      <ConnectWallet
        modalSize={"wide"}
        welcomeScreen={{
          title: "UNLEASH YOUR INNER BAD BOY...",
          img: {
            src: "https://i.ibb.co/fqHP9YD/promo.gif",
            width: 150,
            height: 150,
          },
        }}
        modalTitleIconUrl={"https://i.ibb.co/JQVxMcK/Untitled-1-1.png"}
        termsOfServiceUrl={"https://bb3.io/policies/terms-of-service"}
      />

      {/* Conditionally render 'Mint via Contract' section if a wallet is connected */}
      {userWalletAddress && (
        <>
          <div className="mint-controls">
            <select
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              className="quantity-picker-container quantity-picker select"
            >
              {Array.from({ length: 50 }, (_, i) => i + 1).map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>

            <button onClick={handleMint} className="mint-button">
              Mint via Contract
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const HomePage: React.FC = () => {
  return (
    <ThirdwebProvider
      activeChain= "ethereum"
      clientId="965e7ad5989b7d2a8f197b99bfdf5549"
      supportedWallets={[
        metamaskWallet(),
        coinbaseWallet({ recommended: true }),
        walletConnect(),
        trustWallet(),
      ]}
      theme={darkTheme({
        colors: {
          accentText: "#FFF",
          accentButtonBg: "#333",
        },
      })}
    >
      <div className="centered-container">
        <WalletConnectedContent />
      </div>
    </ThirdwebProvider>
  );
};

export default HomePage;
